import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.up('xs')]: { paddingLeft: 15, paddingRight: 15 },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 11,
      paddingRight: 11
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 31,
      paddingRight: 31
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  input: {
    width: '100%'
  },
  formControl: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginTop: 16,
    marginBottom: 8
  },
  root: {
    width: '100%',
    marginTop: '10px'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: 'red'
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  link: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  expansionPanel: {
    marginLeft: 16,
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    borderBottom: '1px solid #DEDEDE',
    '&:before': {
      display: 'none'
    }
  },
  expansionPanelSummary: {
    paddingLeft: 0
  },
  title: {
    [theme.breakpoints.up('xs')]: { marginTop: 20, marginBottom: 15 },
    [theme.breakpoints.up('md')]: {
      marginTop: 30,
      marginBottom: 10
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 46,
      marginBottom: 20
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 73,
      marginBottom: 10
    }
  }
}));
